import React from "react";
import "../styles/VideoPlayerTitle.css";
import VideoPlayerLikeDislike from "./VideoPlayerLikeDislike";

const VideoPlayerTitle = ( {title} ) => {

  return (
    <div className="videoplayer-video-title">
      <span>{ title ? title : "No Title Available"}</span> 
      <VideoPlayerLikeDislike/>
    </div>
  );
};

export default VideoPlayerTitle;